import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["globalSearch"];

  connect() {
    this.hide();
  }

  show() {
    this.element.show();
    this.globalSearchTarget.focus();
  }

  hide() {
    this.element.hide();
  }

  commit_search(query) {
    if(this.element.dataset.billity == 'yes') {
      var account_id_threshold = 8000;                                 // It will take us a while to reach 8k accounts, whereas invoices with id 8k go back to 2019
    } else {
      var account_id_threshold = 1000000;                              // It will take us a while to reach 1M accounts, whereas invoices with id 1M go back to 2015
    }

    query = query.replace(/^\s+|\s+$/g, "");                           // trim whitespace from beginning and end
    query = query.replace(/\:\s+/g, ":");                              // trim any whitespace coming after a colon, like org:
    query = (/^org\:/.test(query)) ? query.replace(/\-/g, "") : query  // trim dashes, if it's an org: search

    var url = `/admin/users?search=${query}`;                          // This is the default search, which is used if it's not just a number

    if (/^f\:\d+$/.test(query)) {
      url = `/admin/our_invoices_search?invoice_number=${query.slice(2)}`; // This is for admins to search in our invocies.
    }
    else if (/^partyid\:\d+$/.test(query)) {
      url = `/admin/misc_references_search?party_id=${query.slice(8)}`; // This is for getting an account related to the party id from Crediflow.
    }
    else if (/^token\:.+$/.test(query)) {
      url = `/admin/misc_references_search?resource_token=${query.slice(6)}`; // This is for translating a resource token.
    }

    if (/^\d+$/.test(query)) {                                         // Is the query a number?
      var id = Number(query)

      if (id < account_id_threshold) {
        url = `/admin/accounts/${id}`;
      } else if(id > 100000000000) {                                   // And it will take a while to reach 100B invoices, so it's an ocr
        url = `/admin/invoice_ocr_search?payment_reference_number=${id}`;
      } else {                                                         // The range in between is perfect for a regular invoice id
        url = `/admin/client_invoice_show?id=${id}`;
      }
    }
    Turbolinks.visit(url);
  }

  keydown(e) {
    switch (e.key) {
      case 'Escape':
        this.globalSearchTarget.blur();
        break;
      case 'Enter':
        this.commit_search(this.globalSearchTarget.value);
    }
  }
}
